import { render, staticRenderFns } from "./profit_transfer_edit.vue?vue&type=template&id=a44cb968&scoped=true"
import script from "./profit_transfer_edit.vue?vue&type=script&lang=js"
export * from "./profit_transfer_edit.vue?vue&type=script&lang=js"
import style0 from "./profit_transfer_edit.vue?vue&type=style&index=0&id=a44cb968&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a44cb968",
  null
  
)

export default component.exports